import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import de from './de/index.json';
import en from './en/index.json';
import sk from './sk/index.json';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en,
      sk,
      de
    },
    lng: 'en',
    fallbackLng: 'en',
    debug: process.env.REACT_APP_DEVELOP === 'true',
    ns: ['translations']
  });

export default i18n;
